import { render, staticRenderFns } from "./activity.vue?vue&type=template&id=b224b86e&scoped=true&"
import script from "./activity.vue?vue&type=script&lang=js&"
export * from "./activity.vue?vue&type=script&lang=js&"
import style0 from "./activity.vue?vue&type=style&index=0&lang=stylus&rel=stylesheet%2Fstylus&"
import style1 from "./activity.vue?vue&type=style&index=1&id=b224b86e&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b224b86e",
  null
  
)

export default component.exports